var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfesionales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.99999C8 2.89542 8.89542 2 9.99999 2H14C15.1045 2 16 2.89542 16 3.99999V6H20C21.1045 6 22 6.89542 22 7.99999V20C22 21.1045 21.1046 22 20 22H3.99999C2.89543 22 2 21.1045 2 20V7.99999C2 6.89543 2.89542 6 3.99999 6H8V3.99999ZM14 3.99999V6H9.99998V3.99999H14ZM3.99999 7.99998H8H16H20L20 7.99999V20L20 20H3.99999L3.99998 20V7.99999L3.99999 7.99998ZM10.8887 10H12.8887V13H15.8887V15H12.8887V18H10.8887V15H7.88867V13H10.8887V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfesionales);
export default __webpack_public_path__ + "static/media/Profesionales.8040b05936f36bbc02f121725227e80e.svg";
export { ForwardRef as ReactComponent };